'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _PublicPurchaseMotionButton = require('pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton');

var _PublicPurchaseMotionButton2 = _interopRequireDefault(_PublicPurchaseMotionButton);

var _UIContactSalesButton = require('ui-addon-upgrades/button/UIContactSalesButton');

var _UIContactSalesButton2 = _interopRequireDefault(_UIContactSalesButton);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIContactSalesButtonStyled = (0, _styledComponents2.default)(_UIContactSalesButton2.default).withConfig({
  displayName: 'BundlesCTA__UIContactSalesButtonStyled'
})(['width:100% !important;height:60px;']);

var PublicPurchaseMotionButtonStyled = (0, _styledComponents2.default)(_PublicPurchaseMotionButton2.default).withConfig({
  displayName: 'BundlesCTA__PublicPurchaseMotionButtonStyled'
})(['width:100% !important;height:60px;display:flex !important;align-items:center !important;justify-content:center !important;']);

var BundlesCTA = function BundlesCTA(_ref) {
  var bundleUrl = _ref.bundleUrl,
      merchandiseIds = _ref.merchandiseIds;

  return _react2.default.createElement(_EnvironmentWrapper2.default, {
    authedNode: _react2.default.createElement(UIContactSalesButtonStyled, {
      responsive: false,
      use: 'primary',
      upgradeData: {
        app: _Tracking.APP,
        screen: 'bundle',
        uniqueId: 'bundle',
        upgradeProduct: 'bundle',
        bundleUrl: bundleUrl,
        merchandiseIds: merchandiseIds
      }
    }),
    publicNode: _react2.default.createElement(PublicPurchaseMotionButtonStyled, {
      use: 'primary',
      nonMerchandiseIdProduct: 'bundle',
      sourceId: 'pricing-middle'
    })
  });
};

exports.default = BundlesCTA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlesCTA.js
// module id = 712
// module chunks = 3 4